export type FAQ_Category = {
  name: string;
  itemsAmount: number;
};

export enum FAQ_PARAM {
  withdraw = "withdraw",
  card = "card",
  pay = "pay",
  phone_finance = "phone_finance",
  physical_card = "physical-card",
  virtual_card = "virtual-card",
}

export enum FAQ_CATEGORIES {
  GENERAL = "GENERAL",
  ACCOUNT_CHANGES = "ACCOUNT_CHANGES",
  PAYMENT = "PAYMENT",
  PHONE_FINANCE = "PHONE_FINANCE",
  PAYJOY_CARD = "PAYJOY_CARD",
  PAYJOY_VIRTUAL_CARD = "PAYJOY_VIRTUAL_CARD",
  WITHDRAWAL = "WITHDRAWAL",
}

function populateStringArray(length: number, attr: string): Array<string> {
  return new Array<string>(length)
    .fill("")
    .map((_, index) => `${attr}[${index}]`);
}

export interface FaqsService {
  categories: FAQ_Category[];
  getCategoryItemsAmount(category: string): number;
  getCategories(filter: FAQ_PARAM): FAQ_Category[];
  getQuestions(category: string): string[];
  getAnswers(category: string): string[];
}

export class MX_FAQS implements FaqsService {
  categories: FAQ_Category[];
  constructor() {
    this.categories = [
      {
        name: FAQ_CATEGORIES.GENERAL,
        itemsAmount: 3,
      },
      {
        name: FAQ_CATEGORIES.ACCOUNT_CHANGES,
        itemsAmount: 4,
      },
      {
        name: FAQ_CATEGORIES.PAYMENT,
        itemsAmount: 14,
      },
      {
        name: FAQ_CATEGORIES.PHONE_FINANCE,
        itemsAmount: 5,
      },
      {
        name: FAQ_CATEGORIES.PAYJOY_CARD,
        itemsAmount: 16,
      },
      {
        name: FAQ_CATEGORIES.PAYJOY_VIRTUAL_CARD,
        itemsAmount: 4,
      },
      {
        name: FAQ_CATEGORIES.WITHDRAWAL,
        itemsAmount: 14,
      },
    ];
  }
  getCategories(filter: FAQ_PARAM): FAQ_Category[] {
    switch (filter) {
      case FAQ_PARAM.withdraw:
        return this.categories.filter(
          (x) => x.name === FAQ_CATEGORIES.WITHDRAWAL
        );
      case FAQ_PARAM.pay:
        return this.categories.filter((x) => x.name === FAQ_CATEGORIES.PAYMENT);
      case FAQ_PARAM.card:
        return this.categories.filter(
          (x) =>
            x.name === FAQ_CATEGORIES.PAYJOY_CARD ||
            x.name === FAQ_CATEGORIES.PAYJOY_VIRTUAL_CARD
        );
      case FAQ_PARAM.physical_card:
        return this.categories.filter(
          (x) => x.name === FAQ_CATEGORIES.PAYJOY_CARD
        );
      case FAQ_PARAM.virtual_card:
        return this.categories.filter(
          (x) => x.name === FAQ_CATEGORIES.PAYJOY_VIRTUAL_CARD
        );
      case FAQ_PARAM.phone_finance:
        return this.categories.filter(
          (x) => x.name === FAQ_CATEGORIES.PHONE_FINANCE
        );
      default:
        return this.categories;
    }
  }

  getCategoryItemsAmount(category: string): number {
    return this.categories.find((x) => x.name === category)?.itemsAmount || 0;
  }

  getQuestions(category: string): string[] {
    return populateStringArray(
      this.getCategoryItemsAmount(category),
      `CL_HELP_${category}_FAQS.QUESTIONS`
    );
  }

  getAnswers(category: string): string[] {
    return populateStringArray(
      this.getCategoryItemsAmount(category),
      `CL_HELP_${category}_FAQS.ANSWERS`
    );
  }
}

export class CO_FAQS implements FaqsService {
  categories: FAQ_Category[];

  constructor() {
    this.categories = [
      {
        name: FAQ_CATEGORIES.GENERAL,
        itemsAmount: 3,
      },
      {
        name: FAQ_CATEGORIES.WITHDRAWAL,
        itemsAmount: 11,
      },
      {
        name: FAQ_CATEGORIES.PAYMENT,
        itemsAmount: 5,
      },
      {
        name: FAQ_CATEGORIES.ACCOUNT_CHANGES,
        itemsAmount: 4,
      },
      {
        name: FAQ_CATEGORIES.PAYJOY_CARD,
        itemsAmount: 16,
      },
      {
        name: FAQ_CATEGORIES.PAYJOY_VIRTUAL_CARD,
        itemsAmount: 4,
      },
    ];
  }

  getCategories(filter: FAQ_PARAM): FAQ_Category[] {
    switch (filter) {
      case FAQ_PARAM.withdraw:
        return this.categories.filter(
          (x) => x.name === FAQ_CATEGORIES.WITHDRAWAL
        );
      case FAQ_PARAM.pay:
        return this.categories.filter((x) => x.name === FAQ_CATEGORIES.PAYMENT);
      case FAQ_PARAM.card:
        return this.categories.filter(
          (x) =>
            x.name === FAQ_CATEGORIES.PAYJOY_CARD ||
            x.name === FAQ_CATEGORIES.PAYJOY_VIRTUAL_CARD
        );
      case FAQ_PARAM.physical_card:
        return this.categories.filter(
          (x) => x.name === FAQ_CATEGORIES.PAYJOY_CARD
        );
      case FAQ_PARAM.virtual_card:
        return this.categories.filter(
          (x) => x.name === FAQ_CATEGORIES.PAYJOY_VIRTUAL_CARD
        );
      default:
        return this.categories;
    }
  }

  getCategoryItemsAmount(category: string): number {
    return this.categories.find((x) => x.name === category)?.itemsAmount || 0;
  }

  getQuestions(category: string): string[] {
    return populateStringArray(
      this.getCategoryItemsAmount(category),
      `CL_HELP_${category}_FAQS.QUESTIONS`
    );
  }

  getAnswers(category: string): string[] {
    return populateStringArray(
      this.getCategoryItemsAmount(category),
      `CL_HELP_${category}_FAQS.ANSWERS`
    );
  }
}
